/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceConfig
 */
export interface WorkspaceConfig {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    realm: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    idpHint: string;
}

/**
 * Check if a given object implements the WorkspaceConfig interface.
 */
export function instanceOfWorkspaceConfig(value: object): value is WorkspaceConfig {
    if (!('realm' in value) || value['realm'] === undefined) return false;
    if (!('idpHint' in value) || value['idpHint'] === undefined) return false;
    return true;
}

export function WorkspaceConfigFromJSON(json: any): WorkspaceConfig {
    return WorkspaceConfigFromJSONTyped(json, false);
}

export function WorkspaceConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'realm': json['realm'],
        'idpHint': json['idpHint'],
    };
}

export function WorkspaceConfigToJSON(value?: WorkspaceConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'realm': value['realm'],
        'idpHint': value['idpHint'],
    };
}

